import { Heading } from '@chakra-ui/react';

const SubTitle = (props: any) => {
  return (
    <Heading fontSize={'16px'} fontWeight="semibold">
      {props.children}
    </Heading>
  );
};

export default SubTitle;
